import { BlogSection, BlogSubSection } from './api/blog';

export type MediaSectionSlug = 'newsletter' | 'opinion' | 'news' | 'cases' | 'friends';

export interface SubSectionOption {
  label: string;
  englishLabel: string;
  value: BlogSubSection;
}

export interface MediaSection {
  slug: MediaSectionSlug;
  label: string;
  englishLabel: string;
  description: string;
  /** 백엔드 BlogSection ENUM 값 */
  backendSection: BlogSection;
  /** Contentful category names that belong to this section */
  contentfulCategories: string[];
  /** 하위 섹션 필터 (NEWS 섹션만 사용) */
  subSections: SubSectionOption[];
}

export const MEDIA_SECTIONS: MediaSection[] = [
  {
    slug: 'newsletter',
    label: '뉴스레터',
    englishLabel: 'News Letter',
    description: '계약·법률 분야의 최신 트렌드와 실무 인사이트를 전달합니다.',
    backendSection: 'NEWSLETTER',
    contentfulCategories: ['News Letter', '시사 법률 시리즈'],
    subSections: [],
  },
  {
    slug: 'opinion',
    label: '오피니언',
    englishLabel: 'Opinion',
    description: '법률 전문가의 시각으로 계약과 법무를 깊이 분석합니다.',
    backendSection: 'OPINION',
    contentfulCategories: ['Opinion'],
    subSections: [],
  },
  {
    slug: 'cases',
    label: '업무사례',
    englishLabel: 'Cases',
    description: '실제 법률 업무 사례를 통해 계약 리스크를 이해합니다.',
    backendSection: 'CASES',
    contentfulCategories: ['눈여겨 볼 판례'],
    subSections: [],
  },
  {
    slug: 'news',
    label: '로킷소식',
    englishLabel: 'Lawkit News',
    description: '로킷의 새로운 소식과 주요 활동을 공유합니다.',
    backendSection: 'NEWS',
    contentfulCategories: ['News', 'Seminar', 'Webinar'],
    subSections: [
      { label: '언론보도', englishLabel: 'Press', value: 'PRESS' },
      { label: '웨비나', englishLabel: 'Webinar', value: 'WEBINAR' },
      { label: '세미나', englishLabel: 'Seminar', value: 'SEMINAR' },
      { label: '이벤트', englishLabel: 'Event', value: 'EVENT' },
    ],
  },
  {
    slug: 'friends',
    label: '로킷프렌즈',
    englishLabel: 'LawKit Friends',
    description: '로킷과 함께하는 다양한 파트너의 이야기와 활동을 소개합니다.',
    backendSection: 'FRIENDS',
    contentfulCategories: [],
    subSections: [],
  },
];

export const SECTION_MAP: Record<MediaSectionSlug, MediaSection> = Object.fromEntries(MEDIA_SECTIONS.map(s => [s.slug, s])) as Record<MediaSectionSlug, MediaSection>;

export function isValidSection(slug: string): slug is MediaSectionSlug {
  return slug in SECTION_MAP;
}

/**
 * 백엔드 섹션 ENUM 으로 섹션 정의를 찾는다. 섹션이 없는 글(Contentful 카테고리 미분류)은 undefined 다.
 *
 * 화면에 보이는 브레드크럼과 BreadcrumbList 스키마가 같은 이름·경로를 쓰도록 여기 한 곳만 본다.
 */
export function findMediaSectionBySection(section: BlogSection | null | undefined): MediaSection | undefined {
  if (!section) return undefined;
  return MEDIA_SECTIONS.find(candidate => candidate.backendSection === section);
}
